(() => {
  'use strict';
  if (window.p5HandpaintedCartBound) return;
  window.p5HandpaintedCartBound = true;
  const root = window.Shopify?.routes?.root || '/';
  // Safari may show :focus-visible after a touch-activated fragment link.
  // Preserve native scrolling/focus and distinguish only the activation method.
  document.addEventListener('click', event => {
    if (!event.target.closest('.p5-handpainted-shop-now')) return;
    const inventory = document.getElementById('p5-available-boards');
    if (inventory) inventory.toggleAttribute('data-p5-pointer-jump', event.detail > 0);
  }, true);
  document.addEventListener('keydown', () => {
    document.getElementById('p5-available-boards')?.removeAttribute('data-p5-pointer-jump');
  }, true);
  async function refreshCart() {
    try {
      const response = await fetch(root + 'cart.js', {headers: {Accept: 'application/json'}, cache: 'no-store'});
      if (!response.ok) return;
      const cart = await response.json();
      document.querySelectorAll('[data-bind="itemCount"], [data-cart-count]').forEach(node => { node.textContent = String(cart.item_count); });
      document.querySelectorAll('[data-ajax-cart-trigger]').forEach(node => { node.classList.toggle('has-cart-count', cart.item_count > 0); });
      if (window.PXUTheme?.jsAjaxCart?.updateView) window.PXUTheme.jsAjaxCart.updateView();
    } catch (_) { /* The addition succeeded; a cart-display refresh can be retried by opening the cart. */ }
  }
  document.addEventListener('change', event => {
    const select = event.target.closest('[data-p5-inventory-form] select[name="id"]');
    if (!select) return;
    const price = select.closest('.p5-handpainted-card').querySelector('[data-p5-inventory-price]');
    if (price) price.textContent = select.selectedOptions[0].dataset.price;
  });
  document.addEventListener('submit', async event => {
    const form = event.target.closest('[data-p5-inventory-form]');
    if (!form) return;
    event.preventDefault();
    event.stopPropagation();
    const button = form.querySelector('button[type="submit"]');
    const status = form.querySelector('[data-p5-inventory-status]');
    if (form.dataset.state || button.disabled || !form.reportValidity()) return;
    const payload = new FormData(form);
    form.dataset.state = 'pending';
    button.disabled = true;
    button.textContent = 'Adding…';
    form.setAttribute('aria-busy', 'true');
    form.querySelectorAll('select').forEach(node => { node.disabled = true; });
    status.textContent = '';
    let uncertain = true;
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 25000);
    try {
      const response = await fetch(root + 'cart/add.js', {method: 'POST', body: payload, headers: {Accept: 'application/json'}, signal: controller.signal});
      if (!response.ok) uncertain = false;
      const result = await response.json();
      if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : 'This board could not be added. Please try again.');
      form.dataset.state = 'added';
      button.textContent = 'Added to Cart';
      status.textContent = 'Added to your cart.';
      await refreshCart();
    } catch (error) {
      if (uncertain) {
        form.dataset.state = 'uncertain';
        button.textContent = 'Check Cart';
        status.textContent = 'Unable to confirm this addition. Check your cart before trying again.';
      } else {
        delete form.dataset.state;
        button.disabled = false;
        button.textContent = 'Add to Cart';
        form.querySelectorAll('select').forEach(node => { node.disabled = false; });
        status.textContent = error.message || 'This board could not be added. Please try again.';
      }
    } finally {
      clearTimeout(timer);
      form.removeAttribute('aria-busy');
    }
  });
})();
